import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { Icon, IconNames, Tooltip, TooltipTrigger } from '@sovryn/ui';
import { Decimal } from '@sovryn/utils';
import { formatValue, getDecimalPartLength, decimalic } from 'utils/math';
import { calculateDecimalPlaces, isValueBetweenZeroAndOne, } from './AmountRenderer.utils';
import { toast } from 'react-toastify';
export const AmountRenderer = ({ value, className, precision = 4, suffix = '', prefix = '', dataAttribute, useTooltip = true, showRoundingPrefix = true, trigger = TooltipTrigger.click, decimals = 18, asIf, }) => {
    const adjustedValue = useMemo(() => !value || value === 0 || value === '0'
        ? Decimal.ZERO
        : asIf
            ? Decimal.from(value)
            : Decimal.from(value).asUnits(decimals), [asIf, decimals, value]);
    const copyAddress = useCallback(async () => {
        await navigator.clipboard.writeText(String(adjustedValue));
        toast.success(`Copied`);
    }, [adjustedValue]);
    const valueIsRounded = useMemo(() => getDecimalPartLength(adjustedValue) > precision, [adjustedValue, precision]);
    const shouldShowRoundingPrefix = useMemo(() => valueIsRounded && showRoundingPrefix, [valueIsRounded, showRoundingPrefix]);
    const shouldShowTooltip = useMemo(() => useTooltip && valueIsRounded, [useTooltip, valueIsRounded]);
    const calculatedPrecision = useMemo(() => calculateDecimalPlaces(adjustedValue, precision), [adjustedValue, precision]);
    const localeFormattedValue = useMemo(() => formatValue(adjustedValue, isValueBetweenZeroAndOne(Number(adjustedValue))
        ? calculatedPrecision
        : precision), [adjustedValue, calculatedPrecision, precision]);
    return (_jsx(Tooltip, { content: _jsxs("span", { className: "flex items-center", children: [`${prefix} ${decimalic(adjustedValue)} ${suffix}`, _jsx("span", { className: "ml-1 cursor-pointer hover:bg-gray-20 p-1 rounded text-gray-50", onClick: copyAddress, children: _jsx(Icon, { icon: IconNames.COPY }) })] }), className: classNames({
            'cursor-pointer': shouldShowTooltip,
        }), disabled: !shouldShowTooltip, trigger: trigger, dataAttribute: dataAttribute, children: _jsx("span", { className: className, children: _jsxs(_Fragment, { children: [shouldShowRoundingPrefix ? '~ ' : '', prefix, localeFormattedValue, " ", suffix] }) }) }));
};
